export const matrix = () => `Wake up, Neo...
The Matrix has you...
Follow the white rabbit.
`;
